module.exports = __webpack_public_path__ + "img/george-ngobeni.55c1c991.png";